module.exports = __webpack_public_path__ + "static/media/write.c5d232b6.svg";